<template>
  <div id="sideMenu">
    <el-menu :default-active="defaultRouter" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
      @select="handleSelect" text-color="#fff" :router="true" :unique-opened="true" :collapse-transition="false"
      :collapse="isCollapse" active-text-color="#fff">
      <!-- 循环 路由数据 -->
      <div v-for="(item, index) in $router.options.routes" :key="index" class="el-menu-item-one">
        <!-- 循环路由子集 -->
        <div v-for="(childItem, key) in item.children" :key="key" class="el-menu-item-three">
          <!-- 判断当前菜单是否需要显示出来，因为有些路由不需要显示出来 -->
          <div v-if="childItem.menuRoutr != false" class="el-menu-item-Four">
            <!-- 判断是否有子集的子集，如果有就是二级菜单结构，如果没有就是一级菜单结构 -->
            <div v-if="childItem.children ? childItem.children.length : 0">
              <!-- 管理员显示全部菜单 -->
              <div v-if="userType == '0'">
                <el-submenu :index="childItem.path">
                  <template slot="title">
                    <div class="title-left">
                      <img :src="getMenuIcon(childItem.iconImg)" alt="" class="meun-icon" />
                      <!-- <span :class="'FontFamily ' + 'el-icon-fault-location-' + childItem.iconName "></span> -->
                      <span v-show="!isCollapse" slot="title" class="title-text">{{ childItem.title }}</span>
                    </div>
                  </template>
                  <!-- 循环三级菜单 -->
                  <div v-for="(grandsonItem, ind) in childItem.children" :key="ind">
                    <div v-if="grandsonItem.menuRoutr != false">
                      <el-menu-item :index="grandsonItem.path">
                        <span slot="title">{{ grandsonItem.title }}</span>
                      </el-menu-item>
                    </div>
                  </div>
                </el-submenu>
              </div>
              <!-- 非管理员显示除公司管理之外的菜单 -->
              <div v-else-if="userType != '0' && childItem.path != '/companyManagement'
                ">
                <el-submenu :index="childItem.path">
                  <template slot="title">
                    <div class="title-left">
                      <img :src="getMenuIcon(childItem.iconImg)" alt="" class="meun-icon" />
                      <!-- <span :class="'FontFamily ' + 'el-icon-fault-location-' + childItem.iconName "></span> -->
                      <span v-show="!isCollapse" slot="title" class="title-text">{{ childItem.title }}</span>
                    </div>
                  </template>
                  <!-- 循环三级菜单 -->
                  <div v-for="(grandsonItem, ind) in childItem.children" :key="ind">
                    <div v-if="grandsonItem.menuRoutr != false">
                      <el-menu-item :index="grandsonItem.path">
                        <span slot="title">{{ grandsonItem.title }}</span>
                      </el-menu-item>
                    </div>
                  </div>
                </el-submenu>
              </div>
            </div>
            <!-- 只有一级菜单结构 -->
            <div v-else>
              <div class="el-menu-item-onlyOne">
                <el-menu-item :index="childItem.path">
                  <img :src="getMenuIcon(childItem.iconImg)" alt="" class="meun-icon" />
                  <!-- <span :class="'FontFamily ' + 'el-icon-fault-location-' + childItem.iconName "></span> -->
                  <span slot="title" class="title-text">{{
                    childItem.title
                  }}</span>
                </el-menu-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "sideMenu",
  inject: ["reload"],
  data() {
    return {
      defaultRouter: "",
      isCollapse: false, // 是否需要折叠菜单
      userType: "", // 用户类型 0 管理员 1 普通用户
    };
  },
  computed: {
    getMenuIcon() {
      // 菜单图标
      return (data) => {
        if (data) {
          return require(`../../assets/img/menuIcon/${data}.png`);
        } else {
          return "";
        }
      };
    },
  },
  created() {
    this.permissionJudge(); // 调用权限判断方法
    this.userType = this.$utils.getSession("USER_Type"); // 获取用户类型  // 用户类型 0 管理员 1 普通用户
    this.defaultRouter = this.$route.path;
  },
  methods: {
    jump(pathName, id) {
      this.$emit("changeTitle", "/" + pathName); // 触发当前页面包屑改变

      if (id) {
        this.$router.push({
          name: pathName,
          query: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          name: pathName,
        });
      }
    },
    controlMenuStatus() {
      this.isCollapse = !this.isCollapse;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$emit("changeTitle", key); // 触发当前页面包屑改变
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    permissionJudge() {
      // 权限判断
      this.permission = this.$utils.getSession("PERMISSION");
      if (this.$utils.getSession("PERMISSION")) {
      } else {
        this.isAdmin = true;
      }
    },
  },
};
</script>
<style lang="scss">
.el-aside {
  height: 150px;
  overflow: hidden !important;
  width: 100vw !important;
  background: linear-gradient(180deg, rgba(4, 87, 129, 1) 0%, rgba(34, 117, 156, 1) 100%, rgba(34, 117, 156, 1) 100%);

  // 公司样式
  .header-left_icon {
    float: left;
    width: 447px;
    height: 100%;
    background: #fff;

  }

  ul {
    background: transparent !important;

    li {
      width: 100%;
      background: transparent !important;

      div {
        background: transparent !important;
      }

      .el-submenu__title {
        font-size: 16px;
        color: #FFFFFF !important;
      }

      .el-menu-item {
        font-size: 16px;
        color: #FFFFFF !important;
      }
    }

    li:hover {
      background: transparent !important;
    }

    .el-menu-item {
      border-left: 5px solid transparent;
    }

    // 只有一级菜单选中效果
    .el-menu-item.is-active {
      // border-left: 5px solid rgba(114, 192, 179, 1);
      background: rgba(107, 184, 187, 0.2) !important;
    }
  }

  .el-submenu.is-opened {
    background: transparent !important;

    .el-submenu__title {
      background: transparent !important;
    }

    .el-menu {
      background: transparent !important;

      .el-menu-item {
        background: transparent !important;
      }
    }
  }

  #sideMenu {
    .el-menu-item-three {
      .el-menu-item:hover {
        background: rgba(107, 184, 187, 0.2) !important;
      }
    }
  }

  #sideMenu>.el-menu {
    border-right: none !important;
  }

  .el-menu-item-Four {
    .el-submenu {

      // 一级菜单标题
      .el-submenu__title {
        padding: 0px 42px !important;

        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-direction: row;

        .title-left {
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          flex-direction: row;
        }
      }

      // 二级菜单
      .el-menu {

        .el-menu-item {
          padding-left: 66px !important;
        }
      }
    }

    .meun-icon {
      display: block;
      width: 20px;
      height: 20px;
    }

    .title-text {
      margin-left: 16px;
    }

    // 二级菜单选中效果
    .el-menu {
      .el-menu-item.is-active {
        border-left: 5px solid rgba(114, 192, 179, 1);
        background: rgba(107, 184, 187, 0.2) !important;
      }
    }
  }

  // 只有一级菜单
  .el-menu-item-onlyOne {
    .el-menu-item {
      padding: 0px 37px !important;

      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: flex-start;
      justify-content: flex-start;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      flex-direction: row;

      // 只剩图标时的样式微调
      .el-tooltip {
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex !important;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-direction: row;

        padding: 0 !important;
      }
    }
  }

  // 滚动条
  .__vuescroll.hasVBar {
    height: calc(100% - 80px) !important;
  }
}

// 当菜单折叠起来时，弹出层的二级菜单
.el-menu--vertical {
  .el-menu-item {
    // 弹出层菜单高度
    height: 50px;
  }

  span {
    color: #738292;
  }
}

// 当菜单折叠起来时
.el-menu--collapse {
  width: 100% !important;

  .el-menu-item-Four {
    .el-submenu {

      // 一级菜单标题
      .el-submenu__title {
        padding: 0px 20px 0px 30px !important;

        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-direction: row;

        .el-icon-arrow-right {
          display: none;
        }
      }
    }
  }
}
</style>
